import * as React from 'react';
import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { DateRange } from 'owa-datetime-utils';
import DayPickerRenderer from './DayPickerRenderer';
import { getPublishedCalendarLeftPaneStore } from '../store/publishedCalendarLeftPaneStore';
import { observer } from 'mobx-react-lite';
import PublishedCalendarHamburgerButton from './PublishedCalendarHamburgerButton';
import toggleLeftPane from '../actions/toggleLeftPane';

const styles = require('./PublishedCalendarLeftPane.scss');

/**
 * Autofocus should be disabled on initial page load to respect normal tab flow,
 * but then become enabled after the first time the button is clicked as a workaround
 * to "preserve" focus on the button post-click (even though the component actually
 * unmounts and remounts in a different DOM position to accomodate the left nav changes).
 *
 * This workaround can be removed if/when the DOM can be restructured/simplified to ensure that
 * the initial component instance can be preserved rather than unmounted and remounted elsewhere.
 */
let shouldAutoFocusHamburgerButton: boolean = false;

/**
 * Published calendar left pane properties
 */
export interface PublishedCalendarLeftPaneProps {
    surfaceStore: CalendarSurfaceStore;
    onDateRangeChange: (dateRange: DateRange) => void;
}

/**
 * Published calendar left pane UI
 */
export default observer(function PublishedCalendarLeftPane(props: PublishedCalendarLeftPaneProps) {
    const isLeftPaneExpanded = getPublishedCalendarLeftPaneStore().isLeftPaneExpanded;

    return isLeftPaneExpanded ? (
        <div className={styles.leftPane}>
            <div className={styles.leftPaneFirstRow}>
                <PublishedCalendarHamburgerButton
                    autoFocus={shouldAutoFocusHamburgerButton}
                    isPaneExpanded={isLeftPaneExpanded}
                    toggleHamburgerButton={toggleCalendarLeftPaneExpansionOnClick}
                />
            </div>
            <div className={styles.dayPicker}>
                <DayPickerRenderer
                    surfaceStore={props.surfaceStore}
                    onDateRangeChange={props.onDateRangeChange}
                />
            </div>
        </div>
    ) : (
        <div className={styles.leftPaneCollapsed}>
            <PublishedCalendarHamburgerButton
                autoFocus={shouldAutoFocusHamburgerButton}
                isPaneExpanded={isLeftPaneExpanded}
                toggleHamburgerButton={toggleCalendarLeftPaneExpansionOnClick}
            />
        </div>
    );
});

/**
 * Called when the hamburger is clicked
 */
function toggleCalendarLeftPaneExpansionOnClick() {
    shouldAutoFocusHamburgerButton = true;
    toggleLeftPane();
}
